module.exports = __webpack_public_path__ + "img/prolongation-bg-1.2c05032.jpeg";